import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { all_routes } from "../../router/all_routes";
import Api from "../../../core/data/redux/utils/apiCall";
import {
  APPOINTMENT_HOLDING_OPTIONS,
  ATTESTATION_INSTRUCTIONS,
  BLOOD_GROUP_FALLBACK,
  DEGREE_FALLBACK,
  FILE_TYPE_FALLBACK,
  LEGAL_QUESTIONS,
  MANDATORY_FILE_TYPES,
  MARITAL_STATUS_OPTIONS,
  NATIONALITY_OPTIONS,
  RELATION_OPTIONS,
  RELIGION_FALLBACK,
  SECTION_13A_NOTE,
  SECTION_13B_NOTE,
  SECTION_13_PARTICULARS,
  YES_NO_OPTIONS,
  calcPresentAge,
  canEditRequest,
  createOrUpdateEAttestation,
  fetchAllMasterOptions,
  formatPresentAge,
  getMasterOptionsByType,
  fileToBase64,
  findOneEAttestationRequest,
  genderLabel,
  genderPayloadValue,
  getApiMessage,
  getEAttestationReqId,
  fetchFatherNameFromMyProfile,
  getEmployeeDisplayName,
  getFatherNameFromFamilyRows,
  getFatherNameFromLoggedInProfile,
  getFileMime,
  getLoggedInEmpId,
  getLoggedInUser,
  getToReferences,
  masterSelectOptions,
  nationalityLabel,
  nationalityValue,
  padAge,
  pick,
  resolveAttachmentFileType,
  resolveMasterValue,
  asRowList,
  pickAttachmentContent,
  hasUploadedAttachment,
  toInputDate,
  toSapDate,
  toYesNo,
  viewBase64File,
} from "./eAttestation.service";
import { IdentificationCertificate } from "./IdentificationCertificate";

type MasterOpt = { type_id: string; type_text: string };

const emptyResidence = () => ({
  fromDate: "",
  toDate: "",
  address: "",
  districtHq: "",
});
const emptyEducation = () => ({
  educationLevel: "",
  instituteName: "",
  boardOrUniversity: "",
  rollNo: "",
  startDate: "",
  endDate: "",
  division: "",
  courseName: "",
  percentage: "",
  fileName: "",
  fileContent: "",
  fileMime: "",
});
const emptyAppointment = () => ({
  startDate: "",
  endDate: "",
  designation: "",
  organization: "",
  reason: "",
  appointmentType: "",
});
const emptyAttachment = (fileType = "") => ({
  fileType,
  fileDescription: "",
  fileName: "",
  fileContent: "",
  fileMime: "",
});
const defaultAttachments = () =>
  MANDATORY_FILE_TYPES.map((item) => emptyAttachment(item.value));
const emptyFamily = () => ({
  relationType: "",
  name: "",
  phoneNo: "",
  nationality: "Ind",
  dateOfBirth: "",
  occupation: "",
  monthlyIncome: "",
  presentAddress: "",
  permanentAddress: "",
  placeOfBirth: "",
  fileName: "",
  fileContent: "",
  fileMime: "",
});
const emptyForeign = () => ({
  childName: "",
  nationalityByBirth: "",
  countryStudyingIn: "",
  studyingSinceDate: "",
  placeOfBirthState: "",
});

const defaultLegal = () =>
  LEGAL_QUESTIONS.reduce((acc, q) => {
    acc[q.key] = "NO";
    return acc;
  }, {} as Record<string, string>);

const EAttestationForm: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const routes = all_routes;
  const user = getLoggedInUser();
  const details = user?.details || {};
  const empId = getLoggedInEmpId();
  const fullName = getEmployeeDisplayName(user).toUpperCase();
  const designation =
    details?.sap_department_designation_wings?.designation_name ||
    details?.designation_details?.longText ||
    details?.designation ||
    "";
  const dateOfJoining = toInputDate(details?.date_of_joining);
  const dateOfBirth = toInputDate(details?.birthdate || details?.date_of_birth);
  const presentAge = calcPresentAge(dateOfBirth);
  const gender = String(details?.gender || details?.sex || details?.gender_text || "").trim();
  const payScale = String(details?.pay_scale || details?.payscale || "");
  const recruitCategory = String(
    details?.recruitment_category || details?.category || details?.caste || "GENERAL"
  ).toUpperCase();
  const firstnameFromProfile = String(details?.firstname || "").trim();
  const lastname = String(details?.lsastname || details?.lastname || "").trim();

  const [loading, setLoading] = useState(!!id);
  const [saving, setSaving] = useState<"C" | "D" | null>(null);
  const [recordId, setRecordId] = useState<any>("");
  const [reqid, setReqid] = useState("");
  const [mobileNo, setMobileNo] = useState(String(details?.phone || details?.mobile || "").replace(/\D/g, "").slice(0, 10));
  const [alternateMobileNo, setAlternateMobileNo] = useState("");
  const [emailID, setEmailID] = useState(String(details?.email || user?.email || ""));
  const [firstName, setFirstName] = useState(firstnameFromProfile);
  const [marritalStatus, setMarritalStatus] = useState(mapMarital(details?.marital_status));
  const [bloodGroup, setBloodGroup] = useState(String(details?.blood_group || "").toUpperCase());
  const [pwd, setPwd] = useState("NO");
  const [pwdType, setPwdType] = useState("");
  const [exServiceMan, setExServiceMan] = useState("NO");
  const [ews, setEws] = useState("NO");
  const [ewsCertificateNo, setEwsCertificateNo] = useState("");
  const [ewsCertificateValidDate, setEwsCertificateValidDate] = useState("");
  const [presentAddressFull, setPresentAddressFull] = useState("");
  const [presentAddrPoliceStation, setPresentAddrPoliceStation] = useState("");
  const [presentAddrDistrict, setPresentAddrDistrict] = useState("");
  const [presentAddrHouseNo, setPresentAddrHouseNo] = useState("");
  const [presentAddrLaneStreet, setPresentAddrLaneStreet] = useState("");
  const [presentAddrDistHeadQuartAndPin, setPresentAddrDistHeadQuartAndPin] = useState("");
  const [presentAddressState, setPresentAddressState] = useState("");
  const [permanantAddressFull, setPermanantAddressFull] = useState("");
  const [permanantAddrPoliceStationnant, setPermanantAddrPoliceStationnant] = useState("");
  const [permanantAddrDistrict, setPermanantAddrDistrict] = useState("");
  const [permanantAddrHouseNo, setPermanantAddrHouseNo] = useState("");
  const [permanantAddrLaneStreet, setPermanantAddrLaneStreet] = useState("");
  const [permanantDistHeadQuartAndPin, setPermanantDistHeadQuartAndPin] = useState("");
  const [permanentAddressState, setPermanentAddressState] = useState("");
  const [migratedFromPakOrBangladesh, setMigratedFromPakOrBangladesh] = useState("NO");
  const [migrationAddrAndDate, setMigrationAddrAndDate] = useState("");
  const [migrationAddrPoliceStation, setMigrationAddrPoliceStation] = useState("");
  const [migrationAddrDistrictNo, setMigrationAddrDistrictNo] = useState("");
  const [migrationAddrHouseNo, setMigrationAddrHouseNo] = useState("");
  const [migrationAddrLaneStreet, setMigrationAddrLaneStreet] = useState("");
  const [migrationAddrPincode, setMigrationAddrPincode] = useState("");
  const [migrationAddrState, setMigrationAddrState] = useState("");
  const [hasChildStudyingAbroad, setHasChildStudyingAbroad] = useState("NO");
  const [ageAtMatriculation, setAgeAtMatriculation] = useState("");
  const [birthDistrictAndState, setBirthDistrictAndState] = useState("");
  const [fatherBirthDistrictAndState, setFatherBirthDistrictAndState] = useState("");
  const [nationality, setNationality] = useState(
    nationalityValue(details?.nationality || details?.natio || "IN")
  );
  const [religion, setReligion] = useState(String(details?.religion || "").trim());
  const [scStObc, setScStObc] = useState("NO");
  const [subCast, setSubCast] = useState("");
  const [issuingAuthority, setIssuingAuthority] = useState("");
  const [addressAuthority, setAddressAuthority] = useState("");
  const [holdsOrHeldGovtAppointment, setHoldsOrHeldGovtAppointment] = useState("NO");
  const [govtDisciplinaryProceedings, setGovtDisciplinaryProceedings] = useState("NO");
  const [legal, setLegal] = useState<Record<string, string>>(defaultLegal());
  const [specificAnswers, setSpecificAnswers] = useState("");
  const [reference1Name, setReference1Name] = useState("");
  const [reference1Address, setReference1Address] = useState("");
  const [reference1MobileNo, setReference1MobileNo] = useState("");
  const [reference2Name, setReference2Name] = useState("");
  const [reference2Addresss, setReference2Addresss] = useState("");
  const [reference2MobileNo, setReference2MobileNo] = useState("");
  const [declarationConfirmed, setDeclarationConfirmed] = useState(false);
  const [aadharNo, setAadharNo] = useState(
    String(details?.aadhaarId || details?.aadhar_number || details?.adhar || "").trim()
  );
  const [panNo, setPanNo] = useState(
    String(details?.pan || details?.panNo || details?.pan_number || "").trim()
  );
  const [residences, setResidences] = useState([emptyResidence()]);
  const [education, setEducation] = useState([emptyEducation()]);
  const [appointments, setAppointments] = useState([emptyAppointment()]);
  const [attachments, setAttachments] = useState(defaultAttachments());
  const [family, setFamily] = useState([emptyFamily()]);
  const [foreignInfo, setForeignInfo] = useState([emptyForeign()]);
  const [bloodOptions, setBloodOptions] = useState<MasterOpt[]>(BLOOD_GROUP_FALLBACK);
  const [stateOptions, setStateOptions] = useState<MasterOpt[]>([]);
  const [degreeOptions, setDegreeOptions] = useState<MasterOpt[]>(DEGREE_FALLBACK);
  const [religionOptions, setReligionOptions] = useState<MasterOpt[]>(RELIGION_FALLBACK);
  const [nationalityOptions, setNationalityOptions] = useState(NATIONALITY_OPTIONS);
  const [fileTypeOptions, setFileTypeOptions] = useState<MasterOpt[]>(FILE_TYPE_FALLBACK);
  const [pwdOptions, setPwdOptions] = useState<MasterOpt[]>([]);
  const [profileFatherName, setProfileFatherName] = useState(
    getFatherNameFromLoggedInProfile()
  );

  useEffect(() => {
    const loadFatherName = async () => {
      try {
        const name = await fetchFatherNameFromMyProfile(empId);
        if (name) setProfileFatherName(name);
      } catch {
        /* keep empty */
      }
    };
    loadFatherName();
  }, [empId]);

  useEffect(() => {
    const loadMasters = async () => {
      try {
        const byType = await fetchAllMasterOptions();
        const blood = getMasterOptionsByType(byType, "BloodGroup");
        const states = getMasterOptionsByType(byType, "State");
        const degrees = getMasterOptionsByType(byType, "Degree");
        const religions = getMasterOptionsByType(byType, "Religion");
        const files = getMasterOptionsByType(byType, "FileType");
        const pwdTypes = getMasterOptionsByType(byType, "PWD");
        const nationalities = getMasterOptionsByType(byType, "Nationality");
        const nextBlood = blood.length ? blood : BLOOD_GROUP_FALLBACK;
        const nextReligion = religions.length ? religions : RELIGION_FALLBACK;
        setBloodOptions(nextBlood);
        setBloodGroup((prev) => resolveMasterValue(nextBlood, prev));
        if (states.length) setStateOptions(states);
        if (degrees.length) setDegreeOptions(degrees);
        setReligionOptions(nextReligion);
        setReligion((prev) => resolveMasterValue(nextReligion, prev));
        if (nationalities.length) {
          const mapped = nationalities.map((item) => ({
            value: item.type_id || item.type_text,
            label: item.type_text || item.type_id,
          }));
          setNationalityOptions(mapped);
          setNationality((prev) => {
            const match = mapped.find(
              (item) =>
                item.value.toLowerCase() === String(prev || "").toLowerCase() ||
                item.label.toLowerCase() === String(prev || "").toLowerCase()
            );
            return match?.value || nationalityValue(prev);
          });
        }
        if (files.length) {
          setFileTypeOptions(files);
          setAttachments((prev) =>
            prev.map((row) => {
              if (row.fileContent || row.fileName) return row;
              const matched = MANDATORY_FILE_TYPES.find(
                (item) =>
                  item.value === row.fileType ||
                  item.keys.some((key) =>
                    String(row.fileType || "").toUpperCase().includes(key)
                  )
              );
              if (!matched) return row;
              const apiRow = files.find((item) => {
                const blob = `${item.type_id} ${item.type_text}`.toUpperCase();
                return matched.keys.some((key) => blob.includes(key));
              });
              return apiRow ? { ...row, fileType: apiRow.type_id } : row;
            })
          );
        }
        if (pwdTypes.length) setPwdOptions(pwdTypes);
      } catch {
        /* keep empty / fallback options */
      }
    };
    loadMasters();
  }, []);

  useEffect(() => {
    if (!id) return;
    const load = async () => {
      setLoading(true);
      try {
        const data = await findOneEAttestationRequest(decodeURIComponent(id));
        if (!data) {
          toast.error("Request not found");
          navigate(routes.eAttestation.list);
          return;
        }
        if (!canEditRequest(data)) {
          toast.error("This request cannot be edited");
          navigate(
            routes.eAttestation.details.replace(
              ":id",
              encodeURIComponent(getEAttestationReqId(data) || String(pick(data, "Id", "id") || ""))
            )
          );
          return;
        }
        hydrate(data);
      } catch (err: any) {
        toast.error(Api.getErrorMessage(err) || "Failed to load request");
        navigate(routes.eAttestation.list);
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const hydrate = (data: any) => {
    setRecordId(pick(data, "Id", "id"));
    setReqid(String(pick(data, "Reqid", "reqid") || ""));
    setFirstName(String(pick(data, "Firstname", "firstname") || firstnameFromProfile));
    setMobileNo(String(pick(data, "MobileNo") || ""));
    setAlternateMobileNo(String(pick(data, "AlternateMobileNo") || ""));
    setEmailID(String(pick(data, "EmailID") || ""));
    setMarritalStatus(mapMarital(pick(data, "MarritalStatus")));
    setBloodGroup(resolveMasterValue(bloodOptions, pick(data, "BloodGroup")));
    setPwd(toYesNo(pick(data, "Pwd")));
    setPwdType(String(pick(data, "PwdType") || ""));
    setExServiceMan(toYesNo(pick(data, "ExServiceMan")));
    setEws(toYesNo(pick(data, "Ews")));
    setEwsCertificateNo(String(pick(data, "EwsCertificateNo") || ""));
    setEwsCertificateValidDate(toInputDate(pick(data, "EwsCertificateValidDate")));
    setPresentAddressFull(String(pick(data, "PresentAddressFull") || ""));
    setPresentAddrPoliceStation(String(pick(data, "PresentAddrPoliceStation") || ""));
    setPresentAddrDistrict(String(pick(data, "PresentAddrDistrict") || ""));
    setPresentAddrHouseNo(String(pick(data, "PresentAddrHouseNo") || ""));
    setPresentAddrLaneStreet(String(pick(data, "PresentAddrLaneStreet") || ""));
    setPresentAddrDistHeadQuartAndPin(String(pick(data, "PresentAddrDistHeadQuartAndPin") || ""));
    setPresentAddressState(String(pick(data, "PresentAddressState") || ""));
    setPermanantAddressFull(String(pick(data, "PermanantAddressFull") || ""));
    setPermanantAddrPoliceStationnant(String(pick(data, "PermanantAddrPoliceStationnant") || ""));
    setPermanantAddrDistrict(String(pick(data, "PermanantAddrDistrict") || ""));
    setPermanantAddrHouseNo(String(pick(data, "PermanantAddrHouseNo") || ""));
    setPermanantAddrLaneStreet(String(pick(data, "PermanantAddrLaneStreet") || ""));
    setPermanantDistHeadQuartAndPin(String(pick(data, "PermanantDistHeadQuartAndPin") || ""));
    setPermanentAddressState(String(pick(data, "PermanentAddressState") || ""));
    setMigratedFromPakOrBangladesh(toYesNo(pick(data, "MigratedFromPakOrBangladesh")));
    const migRow = (data?.Migration || data?.migration || [])[0] || data;
    setMigrationAddrAndDate(String(pick(migRow, "MigrationAddrAndDate") || pick(data, "MigrationAddrAndDate") || ""));
    setMigrationAddrPoliceStation(String(pick(migRow, "MigrationAddrPoliceStation") || pick(data, "MigrationAddrPoliceStation") || ""));
    setMigrationAddrDistrictNo(String(pick(migRow, "MigrationAddrDistrictNo") || pick(data, "MigrationAddrDistrictNo") || ""));
    setMigrationAddrHouseNo(String(pick(migRow, "MigrationAddrHouseNo") || pick(data, "MigrationAddrHouseNo") || ""));
    setMigrationAddrLaneStreet(String(pick(migRow, "MigrationAddrLaneStreet") || pick(data, "MigrationAddrLaneStreet") || ""));
    setMigrationAddrPincode(String(pick(migRow, "MigrationAddrPincode") || pick(data, "MigrationAddrPincode") || ""));
    setMigrationAddrState(String(pick(migRow, "MigrationAddrState") || pick(data, "MigrationAddrState") || ""));
    setHasChildStudyingAbroad(toYesNo(pick(data, "HasChildStudyingAbroad")));
    setAgeAtMatriculation(String(pick(data, "AgeAtMatriculation") || ""));
    setBirthDistrictAndState(String(pick(data, "BirthDistrictAndState") || ""));
    setFatherBirthDistrictAndState(String(pick(data, "FatherBirthDistrictAndState") || ""));
    setReligion(resolveMasterValue(religionOptions, pick(data, "Religion")));
    setNationality(nationalityValue(pick(data, "Natio", "Nationality") || nationality));
    setScStObc(toYesNo(pick(data, "ScStObc")));
    setSubCast(String(pick(data, "SubCast") || ""));
    setIssuingAuthority(String(pick(data, "IssuingAuthority") || ""));
    setAddressAuthority(String(pick(data, "AddressAuthority") || ""));
    setHoldsOrHeldGovtAppointment(toYesNo(pick(data, "HoldsOrHeldGovtAppointment")));
    setGovtDisciplinaryProceedings(toYesNo(pick(data, "GovtDisciplinaryProceedings")));
    const nextLegal = defaultLegal();
    LEGAL_QUESTIONS.forEach((q) => {
      nextLegal[q.key] = toYesNo(pick(data, q.key, q.legacy));
    });
    setLegal(nextLegal);
    setSpecificAnswers(String(pick(data, "SpecificAnswers") || ""));
    const refs = getToReferences(data);
    setReference1Name(refs[0]?.referenceName || "");
    setReference1Address(refs[0]?.referenceAddress || "");
    setReference1MobileNo(refs[0]?.referenceMobileNo || "");
    setReference2Name(refs[1]?.referenceName || "");
    setReference2Addresss(refs[1]?.referenceAddress || "");
    setReference2MobileNo(refs[1]?.referenceMobileNo || "");
    setDeclarationConfirmed(Boolean(pick(data, "DeclarationConfirmed")));
    setAadharNo(
      String(
        pick(data, "AadharNo", "aadharNo") ||
          details?.aadhaarId ||
          details?.aadhar_number ||
          ""
      ).trim()
    );
    setPanNo(
      String(pick(data, "PanNo", "panNo") || details?.pan || details?.panNo || "").trim()
    );
    const resList = data?.Residence || data?.residence || [];
    setResidences(resList.length ? resList.map((row: any) => ({
      fromDate: toInputDate(pick(row, "FromDate")),
      toDate: toInputDate(pick(row, "ToDate")),
      address: String(pick(row, "ResidenceFullAddress") || ""),
      districtHq: String(pick(row, "DistrictHeadQuarterAddr") || ""),
    })) : [emptyResidence()]);
    const eduList = data?.Education || data?.education || [];
    setEducation(eduList.length ? eduList.map((row: any) => ({
      educationLevel: String(pick(row, "EducationLevel") || ""),
      instituteName: String(pick(row, "InstituteName") || ""),
      boardOrUniversity: String(pick(row, "BoardOrUniversity") || ""),
      rollNo: String(pick(row, "RollNo") || ""),
      startDate: toInputDate(pick(row, "StartDate")),
      endDate: toInputDate(pick(row, "EndDate")),
      division: String(pick(row, "Division") || ""),
      courseName: String(pick(row, "CourseName") || ""),
      percentage: String(pick(row, "PercentageOfMarks") || ""),
      fileName: String(pick(row, "CertificateFileName") || ""),
      fileContent: String(pick(row, "CertificateFileContent") || ""),
      fileMime: String(pick(row, "FileMimeType") || ""),
    })) : [emptyEducation()]);
    const appList = data?.Appointment || data?.appointment || [];
    setAppointments(appList.length ? appList.map((row: any) => ({
      startDate: toInputDate(pick(row, "StartDate")),
      endDate: toInputDate(pick(row, "EndDate")),
      designation: String(pick(row, "Designation") || ""),
      organization: String(pick(row, "OrganizationNameAndAddress") || ""),
      reason: String(pick(row, "ReasonForLeaving") || ""),
      appointmentType: String(pick(row, "AppointmentType") || ""),
    })) : [emptyAppointment()]);
    const attList = asRowList(
      data?.Attachment || data?.attachment || data?.ToAttachment || data?.attachments
    );
    setAttachments(attList.length ? attList.map((row: any) => {
      const fileTypeRaw = String(pick(row, "FileType", "fileType", "SubFileType") || "");
      return {
        fileType: resolveAttachmentFileType(
          { fileType: fileTypeRaw },
          fileTypeOptions
        ) || fileTypeRaw,
        fileDescription: String(pick(row, "FileDescription", "fileDescription", "FileName") || ""),
        fileName: String(pick(row, "FileName", "fileName", "attachmentFileName") || ""),
        fileContent: pickAttachmentContent(row),
        fileMime: String(pick(row, "FileMimeType", "fileMimeType", "attachmentFileType") || ""),
      };
    }) : defaultAttachments());
    const famList = data?.Family || data?.family || [];
    setFamily(famList.length ? famList.map((row: any) => ({
      relationType: String(pick(row, "RelationType") || ""),
      name: String(pick(row, "Name") || ""),
      phoneNo: String(pick(row, "PhoneNo") || ""),
      nationality: nationalityValue(pick(row, "Nationality") || "Ind"),
      dateOfBirth: toInputDate(pick(row, "DateOfBirth")),
      occupation: String(pick(row, "Occupation") || ""),
      monthlyIncome: String(pick(row, "MonthlyIncome") || ""),
      presentAddress: String(pick(row, "PresentAddress") || ""),
      permanentAddress: String(pick(row, "PermanentAddress") || ""),
      placeOfBirth: String(pick(row, "PlaceOfBirth") || ""),
      fileName: String(pick(row, "AttachmentFileName") || ""),
      fileContent: String(pick(row, "AttachmentFileContent") || ""),
      fileMime: String(pick(row, "FileMimeType") || ""),
    })) : [emptyFamily()]);
    const forList = data?.ForeignInfo || data?.foreignInfo || [];
    setForeignInfo(forList.length ? forList.map((row: any) => ({
      childName: String(pick(row, "ChildName") || ""),
      nationalityByBirth: String(pick(row, "NationalityByBirth") || ""),
      countryStudyingIn: String(pick(row, "CountryStudyingIn") || ""),
      studyingSinceDate: toInputDate(pick(row, "StudyingSinceDate")),
      placeOfBirthState: String(pick(row, "PlaceOfBirthState") || ""),
    })) : [emptyForeign()]);
  };

  const validateCreate = (): string[] => {
    const errors: string[] = [];
    const req = (ok: any, label: string) => {
      if (!ok) errors.push(label);
    };

    req(firstName.trim(), "First name");
    req(mobileNo.trim(), "Mobile");
    req(emailID.trim(), "Email");
    req(String(gender || "").trim(), "Gender");
    req(dateOfBirth, "Date of Birth");
    req(marritalStatus, "Marital Status");
    req(bloodGroup, "Blood Group");
    req(exServiceMan, "Ex-Serviceman");

    req(presentAddrHouseNo.trim(), "Present House No");
    req(presentAddrDistrict.trim(), "Present District");
    req(presentAddressState, "Present State");
    req(presentAddrDistHeadQuartAndPin.trim(), "Present District Headquarters and pin code");

    req(permanantAddrHouseNo.trim(), "Permanent House No");
    req(permanantAddrDistrict.trim(), "Permanent District");
    req(permanentAddressState, "Permanent State");
    req(permanantDistHeadQuartAndPin.trim(), "Permanent District Headquarters and pin code");

    req(residences.some((r) => r.fromDate || r.toDate || r.address.trim()), "Residence (at least one record)");
    req(education.some((r) => r.educationLevel || r.instituteName.trim()), "Education (at least one record)");
    if (toYesNo(holdsOrHeldGovtAppointment) === "YES") {
      req(
        appointments.some((r) => r.startDate || r.designation.trim() || r.organization.trim()),
        "Past Employment History (at least one record)"
      );
    }
    req(attachments.some(hasUploadedAttachment), "Attachment (at least one file)");
    req(family.some((r) => r.relationType || r.name.trim()), "Family (at least one record)");

    if (toYesNo(ews) === "YES") req(ewsCertificateValidDate, "EWS Certificate Valid Date");
    if (toYesNo(pwd) === "YES") req(pwdType, "PWD Type");
    if (toYesNo(migratedFromPakOrBangladesh) === "YES") {
      req(
        migrationAddrAndDate.trim() ||
          migrationAddrHouseNo.trim() ||
          migrationAddrDistrictNo.trim() ||
          migrationAddrState.trim(),
        "Migration details"
      );
    }
    if (toYesNo(hasChildStudyingAbroad) === "YES") {
      req(
        foreignInfo.some((r) => r.childName.trim() || r.countryStudyingIn.trim()),
        "Foreign study details"
      );
    }

    LEGAL_QUESTIONS.forEach((q) => req(legal[q.key], q.label));
    req(govtDisciplinaryProceedings, "Govt Disciplinary Proceedings");

    req(reference1Name.trim(), "Reference 1 Name");
    req(reference1Address.trim(), "Reference 1 Address");
    req(reference1MobileNo.trim(), "Reference 1 Mobile");
    req(reference2Name.trim(), "Reference 2 Name");
    req(reference2Addresss.trim(), "Reference 2 Address");
    req(reference2MobileNo.trim(), "Reference 2 Mobile");

    req(declarationConfirmed === true, "Declaration");
    return errors;
  };

  const buildPayload = (action: "C" | "D") => {
    const filledResidences = residences.filter((r) => r.fromDate || r.toDate || r.address.trim());
    const filledEducation = education.filter((r) => r.educationLevel || r.instituteName.trim());
    const filledAppointments = appointments.filter((r) => r.startDate || r.designation.trim());
    const filledAttachments = attachments.filter(
      (r) => r.fileType || r.fileContent || r.fileName
    );
    const filledFamily = family.filter((r) => r.relationType || r.name.trim());
    const filledForeign = foreignInfo.filter((r) => r.childName.trim() || r.countryStudyingIn.trim());
    const legalPayload: Record<string, string> = {};
    LEGAL_QUESTIONS.forEach((q) => {
      legalPayload[q.key] = toYesNo(legal[q.key]);
      if (q.legacy !== q.key) legalPayload[q.legacy] = toYesNo(legal[q.key]);
    });
    const payload: any = {
      action,
      reqid: reqid || "",
      recruitUnderCatagory: recruitCategory || "GENERAL",
      mobileNo: mobileNo.trim(),
      alternateMobileNo: alternateMobileNo.trim(),
      emailID: emailID.trim(),
      marritalStatus,
      bloodGroup,
      ews,
      pwd,
      ewsCertificateValidDate: toSapDate(ewsCertificateValidDate),
      ewsCertificateNo: ews === "YES" ? ewsCertificateNo : "",
      pwdType: pwd === "YES" ? pwdType : "",
      exServiceMan,
      presentAddressFull,
      presentAddrPoliceStation,
      presentAddrDistrict,
      presentAddrHouseNo,
      presentAddrLaneStreet,
      presentAddrDistHeadQuartAndPin,
      presentAddressState,
      permanantAddressFull,
      permanantAddrPoliceStationnant,
      permanantAddrDistrict,
      permanantAddrHouseNo,
      permanantAddrLaneStreet,
      permanantDistHeadQuartAndPin,
      permanentAddressState,
      migratedFromPakOrBangladesh,
      migrationAddrAndDate: migratedFromPakOrBangladesh === "YES" ? migrationAddrAndDate : "",
      migrationAddrPoliceStation: migratedFromPakOrBangladesh === "YES" ? migrationAddrPoliceStation : "",
      migrationAddrDistrictNo: migratedFromPakOrBangladesh === "YES" ? migrationAddrDistrictNo : "",
      migrationAddrHouseNo: migratedFromPakOrBangladesh === "YES" ? migrationAddrHouseNo : "",
      migrationAddrLaneStreet: migratedFromPakOrBangladesh === "YES" ? migrationAddrLaneStreet : "",
      migrationAddrPincode: migratedFromPakOrBangladesh === "YES" ? migrationAddrPincode : "",
      migrationAddrState: migratedFromPakOrBangladesh === "YES" ? migrationAddrState : "",
      migration:
        migratedFromPakOrBangladesh === "YES" &&
        (migrationAddrAndDate.trim() ||
          migrationAddrHouseNo.trim() ||
          migrationAddrDistrictNo.trim() ||
          migrationAddrState.trim())
          ? [
              {
                Reqid: reqid || "",
                SerialNo: 1,
                MigrationAddrAndDate: migrationAddrAndDate,
                MigrationAddrPoliceStation: migrationAddrPoliceStation,
                MigrationAddrDistrictNo: migrationAddrDistrictNo,
                MigrationAddrHouseNo: migrationAddrHouseNo,
                MigrationAddrLaneStreet: migrationAddrLaneStreet,
                MigrationAddrPincode: migrationAddrPincode,
                MigrationAddrState: migrationAddrState,
              },
            ]
          : [],
      hasChildStudyingAbroad,
      ageAtMatriculation: padAge(ageAtMatriculation),
      birthDistrictAndState,
      fatherBirthDistrictAndState,
      religion,
      scStObc,
      subCast: scStObc === "YES" ? subCast : "",
      issuingAuthority: scStObc === "YES" ? issuingAuthority : "",
      addressAuthority: scStObc === "YES" ? addressAuthority : "",
      holdsOrHeldGovtAppointment,
      govtDisciplinaryProceedings,
      specificAnswers,
      toReference: [
        {
          referenceNo: 1,
          referenceName: reference1Name.trim(),
          referenceAddress: reference1Address.trim(),
          referenceMobileNo: reference1MobileNo.trim(),
        },
        {
          referenceNo: 2,
          referenceName: reference2Name.trim(),
          referenceAddress: reference2Addresss.trim(),
          referenceMobileNo: reference2MobileNo.trim(),
        },
      ],
      declarationConfirmed,
      presentAge,
      firstname: firstName.trim(),
      lastname,
      gender: genderPayloadValue(gender),
      designation,
      payScale,
      natio: nationalityValue(nationality),
      dateOfBirth: toSapDate(dateOfBirth),
      dateOfJoining: toSapDate(dateOfJoining),
      createBy: empId || getLoggedInEmpId(),
      createdate: toSapDate(new Date()),
      incase: specificAnswers || "N/A",
      ...legalPayload,
      residence: filledResidences.map((row, idx) => ({
        Reqid: reqid || "",
        SerialNo: idx + 1,
        FromDate: toSapDate(row.fromDate),
        ToDate: toSapDate(row.toDate),
        ResidenceFullAddress: row.address,
        DistrictHeadQuarterAddr: row.districtHq,
      })),
      education: filledEducation.map((row) => ({
        Reqid: reqid || "",
        EducationLevel: row.educationLevel,
        InstituteName: row.instituteName,
        BoardOrUniversity: row.boardOrUniversity,
        RollNo: row.rollNo,
        StartDate: toSapDate(row.startDate),
        EndDate: toSapDate(row.endDate),
        Division: row.division,
        CourseName: row.courseName,
        PercentageOfMarks: row.percentage || "0.00",
        FileMimeType: row.fileMime,
        CertificateFileName: row.fileName,
        CertificateFileContent: row.fileContent,
      })),
      appointment: toYesNo(holdsOrHeldGovtAppointment) === "YES"
        ? filledAppointments.map((row, idx) => ({
            Reqid: reqid || "",
            SerialNo: idx + 1,
            StartDate: toSapDate(row.startDate),
            EndDate: toSapDate(row.endDate),
            Designation: row.designation,
            OrganizationNameAndAddress: row.organization,
            ReasonForLeaving: row.reason,
            AppointmentType: row.appointmentType,
          }))
        : [],
      attachment: filledAttachments.map((row, idx) => {
        const fileType = resolveAttachmentFileType(row, fileTypeOptions);
        const item: any = {
          Reqid: reqid || "",
          EmpID: empId,
          SerialNo: idx + 1,
          FileType: fileType,
          FileDescription: row.fileDescription || row.fileName,
          FileName: row.fileName || "",
          FileMimeType: row.fileMime || "",
        };
        if (String(row.fileContent || "").trim()) {
          item.FileContent = row.fileContent;
        }
        return item;
      }),
      family: filledFamily.map((row, idx) => ({
        Reqid: reqid || "",
        SerialNo: idx + 1,
        RelationType: row.relationType,
        Name: row.name,
        PhoneNo: row.phoneNo,
        Nationality: nationalityLabel(row.nationality) || row.nationality,
        DateOfBirth: toSapDate(row.dateOfBirth),
        Occupation: row.occupation,
        MonthlyIncome: row.monthlyIncome || "0.00",
        PresentAddress: row.presentAddress,
        PermanentAddress: row.permanentAddress,
        PlaceOfBirth: row.placeOfBirth,
        AttachmentFileName: row.fileName,
        AttachmentFileContent: row.fileContent,
        FileMimeType: row.fileMime,
      })),
      foreignInfo: hasChildStudyingAbroad === "YES"
        ? filledForeign.map((row, idx) => ({
            Reqid: reqid || "",
            SerialNo: idx + 1,
            ChildName: row.childName,
            NationalityByBirth: row.nationalityByBirth,
            CountryStudyingIn: row.countryStudyingIn,
            StudyingSinceDate: toSapDate(row.studyingSinceDate),
            PlaceOfBirthState: row.placeOfBirthState,
          }))
        : [],
    };
    if (recordId) payload.id = Number(recordId) || recordId;
    return payload;
  };

  const handleSubmit = async (action: "C" | "D") => {
    if (action === "C") {
      const errors = validateCreate();
      if (errors.length) {
        toast.error(
          `Final submit incomplete. Missing: ${errors.slice(0, 8).join(", ")}${errors.length > 8 ? "…" : ""}`
        );
        return;
      }
    }
    setSaving(action);
    try {
      const res: any = await createOrUpdateEAttestation(buildPayload(action));
      toast.success(
        getApiMessage(
          res,
          action === "D" ? "Draft saved successfully" : "Attestation form submitted successfully"
        )
      );
      navigate(routes.eAttestation.list);
    } catch (err: any) {
      toast.error(Api.getErrorMessage(err) || "Failed to save request");
    } finally {
      setSaving(null);
    }
  };

  const onFile = async (
    file: File | undefined,
    apply: (name: string, content: string, mime: string) => void
  ) => {
    if (!file) return;
    try {
      const content = await fileToBase64(file);
      apply(file.name, content, getFileMime(file));
    } catch {
      toast.error("Failed to read file");
    }
  };

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content text-center py-5">
          <div className="spinner-border text-danger" role="status" />
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper ea-form">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Attestation Form</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.eAttestation.list}>E-Attestation Process</Link>
                </li>
                <li className="breadcrumb-item active">{id ? "Edit Request" : "Create Request"}</li>
              </ol>
            </nav>
          </div>
          <Link to={routes.eAttestation.list} className="btn btn-light">Back</Link>
        </div>

        <div className="ea-warn mb-3">
          <div className="ea-warn-title">WARNING</div>
          <ol className="mb-0 ps-3">
            {ATTESTATION_INSTRUCTIONS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </div>

        <Box>
          <div className="row g-3">
            <Read label="Request ID" value={reqid || "-"} />
            <Read label="Employee Id" value={empId || "-"} />
            <ReqInput label="First Name" value={firstName} onChange={setFirstName} />
            <ReqInput label="Mobile" value={mobileNo} onChange={setMobileNo} maxLength={10} />
            <ReqInput label="Alternate No" value={alternateMobileNo} onChange={setAlternateMobileNo} maxLength={15} />
            <ReqInput label="Email" value={emailID} onChange={setEmailID} />
            <ReqSelect label="Marital Status" value={marritalStatus} onChange={setMarritalStatus} options={MARITAL_STATUS_OPTIONS} />
            <Read label="Date of Joining" value={dateOfJoining ? dateOfJoining.split("-").reverse().join(".") : "-"} />
            <Read label="PayScale" value={payScale || "-"} />
            <Read label="Gender" value={genderLabel(gender) || "-"} />
            <Read label="Designation" value={designation || "-"} />
            <Read label="Recruit under which Category" value={recruitCategory || "-"} />
            <ReqSelect
              label="Blood Group"
              value={resolveMasterValue(bloodOptions, bloodGroup)}
              onChange={setBloodGroup}
              options={masterSelectOptions(bloodOptions)}
            />
            <ReqSelect label="PWD" value={pwd} onChange={setPwd} options={YES_NO_OPTIONS} />
            {pwd === "YES" ? (
              <ReqSelect
                label="PWD Type"
                value={pwdType}
                onChange={setPwdType}
                options={masterSelectOptions(pwdOptions)}
              />
            ) : null}
            <ReqSelect label="Ex-Serviceman" value={exServiceMan} onChange={setExServiceMan} options={YES_NO_OPTIONS} />
            <ReqSelect label="EWS" value={ews} onChange={setEws} options={YES_NO_OPTIONS} />
            {ews === "YES" ? (
              <>
                <ReqInput label="EWS Certificate No" value={ewsCertificateNo} onChange={setEwsCertificateNo} />
                <ReqInput type="date" label="EWS Certificate Valid Date" value={ewsCertificateValidDate} onChange={setEwsCertificateValidDate} />
              </>
            ) : null}
          </div>
        </Box>

        <Box title="1: Name in Full in Block Letters (Please indicate if you have added or dropped at any stage any part of any name or surname)">
          <p className="fw-bold mb-0">{fullName}</p>
        </Box>

        <Box title="2: Present Address In Full (i.e village in Thana and District or House No, Lane/Street/Road and Town, Pincode)">
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label fw-semibold"><Star /> Present Address In Full</label>
              <textarea className="form-control" rows={3} value={presentAddressFull} onChange={(e) => setPresentAddressFull(e.target.value)} />
            </div>
            <ReqInput label="Police Station" value={presentAddrPoliceStation} onChange={setPresentAddrPoliceStation} />
            <ReqInput label="District" value={presentAddrDistrict} onChange={setPresentAddrDistrict} />
            <ReqInput label="House No" value={presentAddrHouseNo} onChange={setPresentAddrHouseNo} />
            <ReqInput label="Lane/Street/Road and Town" value={presentAddrLaneStreet} onChange={setPresentAddrLaneStreet} />
            <ReqInput label="District Headquarters and pin code" value={presentAddrDistHeadQuartAndPin} onChange={setPresentAddrDistHeadQuartAndPin} />
            {stateOptions.length ? (
              <ReqSelect
                label="State"
                value={presentAddressState}
                onChange={setPresentAddressState}
                options={stateOptions.map((o) => ({ value: o.type_id, label: o.type_text }))}
              />
            ) : (
              <ReqInput label="State" value={presentAddressState} onChange={setPresentAddressState} />
            )}
          </div>
        </Box>

        <Box title="3(A) Home Address in full (i.e Village Thana & District or House No, Lane/Street/Road and Town and name of District Headquarters)">
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label fw-semibold"><Star /> Complete Permanent Address</label>
              <textarea className="form-control" rows={3} value={permanantAddressFull} onChange={(e) => setPermanantAddressFull(e.target.value)} />
            </div>
            <ReqInput label="Police Station" value={permanantAddrPoliceStationnant} onChange={setPermanantAddrPoliceStationnant} />
            <ReqInput label="District" value={permanantAddrDistrict} onChange={setPermanantAddrDistrict} />
            <ReqInput label="House No" value={permanantAddrHouseNo} onChange={setPermanantAddrHouseNo} />
            <ReqInput label="Lane/Street/Road and Town" value={permanantAddrLaneStreet} onChange={setPermanantAddrLaneStreet} />
            <ReqInput label="District Headquarters and pin code" value={permanantDistHeadQuartAndPin} onChange={setPermanantDistHeadQuartAndPin} />
            {stateOptions.length ? (
              <ReqSelect
                label="State"
                value={permanentAddressState}
                onChange={setPermanentAddressState}
                options={stateOptions.map((o) => ({ value: o.type_id, label: o.type_text }))}
              />
            ) : (
              <ReqInput label="State" value={permanentAddressState} onChange={setPermanentAddressState} />
            )}
          </div>
        </Box>

        <Box>
          <ReqSelect label="3(B) Migrated from Pakistan/Bangladesh" value={migratedFromPakOrBangladesh} onChange={setMigratedFromPakOrBangladesh} options={YES_NO_OPTIONS} />
          {migratedFromPakOrBangladesh === "YES" ? (
            <div className="row g-3 mt-1">
              <div className="col-12">
                <label className="form-label fw-semibold"><Star /> If originally resident of Pakistan/Bangladesh (erstwhile East Pakistan), the address in that country and date of migration to India</label>
                <textarea className="form-control" rows={3} value={migrationAddrAndDate} onChange={(e) => setMigrationAddrAndDate(e.target.value)} />
              </div>
              <ReqInput label="Police Station" value={migrationAddrPoliceStation} onChange={setMigrationAddrPoliceStation} />
              <ReqInput label="District" value={migrationAddrDistrictNo} onChange={setMigrationAddrDistrictNo} />
              <ReqInput label="House No" value={migrationAddrHouseNo} onChange={setMigrationAddrHouseNo} />
              <ReqInput label="Lane/Street/Road and Town" value={migrationAddrLaneStreet} onChange={setMigrationAddrLaneStreet} />
              <ReqInput label="District Headquarters and pin code" value={migrationAddrPincode} onChange={setMigrationAddrPincode} />
              <ReqInput label="State" value={migrationAddrState} onChange={setMigrationAddrState} />
            </div>
          ) : null}
        </Box>

        <Box title="4. Particulars of Places (With Period of Residences) where you have been resident for more than one year at a time during the preceding five years. In case of stay abroad (including Pakistan) particulars of all places where you have resided for more than one year after attaining the age of 21 years should be given. (Mandatory)">
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>Sr.No</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Residential Address in Full</th>
                  <th>Name of District Headquarter</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {residences.map((row, idx) => (
                  <tr key={idx} className={idx === 0 ? "table-warning" : ""}>
                    <td>{idx + 1}</td>
                    <td><input type="date" className="form-control form-control-sm" value={row.fromDate} onChange={(e) => updateRow(setResidences, residences, idx, { fromDate: e.target.value })} /></td>
                    <td><input type="date" className="form-control form-control-sm" value={row.toDate} onChange={(e) => updateRow(setResidences, residences, idx, { toDate: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.address} onChange={(e) => updateRow(setResidences, residences, idx, { address: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.districtHq} onChange={(e) => updateRow(setResidences, residences, idx, { districtHq: e.target.value })} /></td>
                    <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setResidences(removeRow(residences, idx, emptyResidence))}>x</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setResidences([...residences, emptyResidence()])}>Add Row</button>
        </Box>

        <Box title="5: Family details (Mandatory)">
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>Sr.No</th>
                  <th>Relationship</th>
                  <th>Name</th>
                  <th>Phone No</th>
                  <th>Nationality</th>
                  <th>Date of Birth</th>
                  <th>Occupation</th>
                  <th>Monthly Income</th>
                  <th>Present Postal Address</th>
                  <th>Permanent Home Address</th>
                  <th>Place of Birth</th>
                  <th>Upload File</th>
                  <th>View File</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {family.map((row, idx) => (
                  <tr key={idx} className={idx === 0 ? "table-warning" : ""}>
                    <td>{idx + 1}</td>
                    <td>
                      <select className="form-select form-select-sm" value={row.relationType} onChange={(e) => updateRow(setFamily, family, idx, { relationType: e.target.value })}>
                        <option value="">Select</option>
                        {RELATION_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
                      </select>
                    </td>
                    <td><input className="form-control form-control-sm" value={row.name} onChange={(e) => updateRow(setFamily, family, idx, { name: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.phoneNo} onChange={(e) => updateRow(setFamily, family, idx, { phoneNo: e.target.value })} /></td>
                    <td>
                      <select className="form-select form-select-sm" value={nationalityValue(row.nationality)} onChange={(e) => updateRow(setFamily, family, idx, { nationality: e.target.value })}>
                        <option value="">Select</option>
                        {nationalityOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                        {row.nationality &&
                        !nationalityOptions.some(
                          (opt) =>
                            opt.value.toLowerCase() === nationalityValue(row.nationality).toLowerCase() ||
                            opt.label.toLowerCase() === String(row.nationality).toLowerCase()
                        ) ? (
                          <option value={row.nationality}>{row.nationality}</option>
                        ) : null}
                      </select>
                    </td>
                    <td><input type="date" className="form-control form-control-sm" value={row.dateOfBirth} onChange={(e) => updateRow(setFamily, family, idx, { dateOfBirth: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.occupation} onChange={(e) => updateRow(setFamily, family, idx, { occupation: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.monthlyIncome} onChange={(e) => updateRow(setFamily, family, idx, { monthlyIncome: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.presentAddress} onChange={(e) => updateRow(setFamily, family, idx, { presentAddress: e.target.value })} placeholder="Present postal address" /></td>
                    <td><input className="form-control form-control-sm" value={row.permanentAddress} onChange={(e) => updateRow(setFamily, family, idx, { permanentAddress: e.target.value })} placeholder="Permanent home address" /></td>
                    <td><input className="form-control form-control-sm" value={row.placeOfBirth} onChange={(e) => updateRow(setFamily, family, idx, { placeOfBirth: e.target.value })} /></td>
                    <td>
                      <input type="file" className="form-control form-control-sm" onChange={(e) => onFile(e.target.files?.[0], (name, content, mime) => updateRow(setFamily, family, idx, { fileName: name, fileContent: content, fileMime: mime }))} />
                      {row.fileName ? <small className="d-block">{row.fileName}</small> : null}
                    </td>
                    <td>
                      {row.fileContent ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => viewBase64File(row.fileContent, row.fileName, row.fileMime)}
                        >
                          View File
                        </button>
                      ) : (
                        <span className="text-muted small">No file</span>
                      )}
                    </td>
                    <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setFamily(removeRow(family, idx, emptyFamily))}>x</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setFamily([...family, emptyFamily()])}>Add Row</button>
        </Box>

        <Box>
          <ReqSelect
            label="5(A) Information to be furnished with regard to son(s) and/or daughter(s) in case they are studying in foreign Country"
            value={hasChildStudyingAbroad}
            onChange={setHasChildStudyingAbroad}
            options={YES_NO_OPTIONS}
          />
          {hasChildStudyingAbroad === "YES" ? (
            <div className="table-responsive mt-2">
              <table className="table table-bordered table-sm align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Sr.No</th>
                    <th>Child Name</th>
                    <th>Nationality by Birth</th>
                    <th>Country Studying In</th>
                    <th>Studying Since</th>
                    <th>Place of Birth State</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {foreignInfo.map((row, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td><input className="form-control form-control-sm" value={row.childName} onChange={(e) => updateRow(setForeignInfo, foreignInfo, idx, { childName: e.target.value })} /></td>
                      <td><input className="form-control form-control-sm" value={row.nationalityByBirth} onChange={(e) => updateRow(setForeignInfo, foreignInfo, idx, { nationalityByBirth: e.target.value })} /></td>
                      <td><input className="form-control form-control-sm" value={row.countryStudyingIn} onChange={(e) => updateRow(setForeignInfo, foreignInfo, idx, { countryStudyingIn: e.target.value })} /></td>
                      <td><input type="date" className="form-control form-control-sm" value={row.studyingSinceDate} onChange={(e) => updateRow(setForeignInfo, foreignInfo, idx, { studyingSinceDate: e.target.value })} /></td>
                      <td><input className="form-control form-control-sm" value={row.placeOfBirthState} onChange={(e) => updateRow(setForeignInfo, foreignInfo, idx, { placeOfBirthState: e.target.value })} /></td>
                      <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setForeignInfo(removeRow(foreignInfo, idx, emptyForeign))}>x</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setForeignInfo([...foreignInfo, emptyForeign()])}>Add Row</button>
            </div>
          ) : null}
        </Box>

        <Box>
          <div className="row g-3">
            <ReqSelect
              label="6 Nationality"
              value={nationalityValue(nationality)}
              onChange={setNationality}
              options={nationalityOptions}
            />
            <Read label="7(A) Date Of Birth" value={dateOfBirth ? dateOfBirth.split("-").reverse().join(".") : "-"} />
            <Read label="7(B) Present Age" value={formatPresentAge(presentAge) || "-"} />
            <ReqInput label="7(C) Age at matriculation" value={ageAtMatriculation} onChange={setAgeAtMatriculation} maxLength={3} />
            <ReqInput label="8(A) Place of Birth District and state in which situated" value={birthDistrictAndState} onChange={setBirthDistrictAndState} />
            <ReqInput label="8(B) District and state to which your father originally belong" value={fatherBirthDistrictAndState} onChange={setFatherBirthDistrictAndState} />
            <ReqSelect
              label="9(A) Your Religion"
              value={resolveMasterValue(religionOptions, religion)}
              onChange={setReligion}
              options={masterSelectOptions(religionOptions)}
            />
            <ReqSelect label="9(B) Are you a member of SC/ST/OBC" value={scStObc} onChange={setScStObc} options={YES_NO_OPTIONS} />
            {scStObc === "YES" ? (
              <>
                <ReqInput label="Subcast" value={subCast} onChange={setSubCast} />
                <ReqInput label="Issuing Authority" value={issuingAuthority} onChange={setIssuingAuthority} />
                <ReqInput label="Address Authority" value={addressAuthority} onChange={setAddressAuthority} />
              </>
            ) : null}
          </div>
        </Box>

        <Box title="10: Education Qualification Showing Place OF Education with year in school and college since 15th years of age. (Mandatory)">
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>Degree</th>
                  <th>Name Of School / College</th>
                  <th>Board / University</th>
                  <th>Roll No</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Division</th>
                  <th>Course Name</th>
                  <th>Percentage of Marks</th>
                  <th>Certificate</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {education.map((row, idx) => (
                  <tr key={idx} className={idx === 0 ? "table-warning" : ""}>
                    <td>
                      <select className="form-select form-select-sm" value={row.educationLevel} onChange={(e) => updateRow(setEducation, education, idx, { educationLevel: e.target.value })}>
                        <option value="">Select</option>
                        {degreeOptions.map((d) => <option key={d.type_id} value={d.type_id}>{d.type_text}</option>)}
                      </select>
                    </td>
                    <td><input className="form-control form-control-sm" value={row.instituteName} onChange={(e) => updateRow(setEducation, education, idx, { instituteName: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.boardOrUniversity} onChange={(e) => updateRow(setEducation, education, idx, { boardOrUniversity: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.rollNo} onChange={(e) => updateRow(setEducation, education, idx, { rollNo: e.target.value })} /></td>
                    <td><input type="date" className="form-control form-control-sm" value={row.startDate} onChange={(e) => updateRow(setEducation, education, idx, { startDate: e.target.value })} /></td>
                    <td><input type="date" className="form-control form-control-sm" value={row.endDate} onChange={(e) => updateRow(setEducation, education, idx, { endDate: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.division} onChange={(e) => updateRow(setEducation, education, idx, { division: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.courseName} onChange={(e) => updateRow(setEducation, education, idx, { courseName: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.percentage} onChange={(e) => updateRow(setEducation, education, idx, { percentage: e.target.value })} /></td>
                    <td>
                      <input type="file" className="form-control form-control-sm" onChange={(e) => onFile(e.target.files?.[0], (name, content, mime) => updateRow(setEducation, education, idx, { fileName: name, fileContent: content, fileMime: mime }))} />
                      {row.fileName ? <small className="d-block">{row.fileName}</small> : null}
                    </td>
                    <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setEducation(removeRow(education, idx, emptyEducation))}>x</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setEducation([...education, emptyEducation()])}>Add Row</button>
        </Box>

        <Box>
          <ReqSelect
            label="11(A) Are you holding or have any time held an appointment under the Central/State Government/Semi-Government/Quasi Government body or autonomous body or public undertaking or a private firm of the institution? If so, give full particulars with the date of employment up to date."
            value={holdsOrHeldGovtAppointment}
            onChange={(value) => {
              setHoldsOrHeldGovtAppointment(value);
              if (value !== "YES") setAppointments([emptyAppointment()]);
            }}
            options={YES_NO_OPTIONS}
          />
          {holdsOrHeldGovtAppointment === "YES" ? (
            <>
          <p className="fw-semibold mt-3 mb-2">Past Employment History (Mandatory)*</p>
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>Sr.No</th>
                  <th>Period From</th>
                  <th>Period To</th>
                  <th>Designation emoluments and nature of Employment</th>
                  <th>Full name and address of employer</th>
                  <th>Reasons For Leaving Previous Service</th>
                  <th>Holding</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {appointments.map((row, idx) => (
                  <tr key={idx} className={idx === 0 ? "table-warning" : ""}>
                    <td>{idx + 1}</td>
                    <td><input type="date" className="form-control form-control-sm" value={row.startDate} onChange={(e) => updateRow(setAppointments, appointments, idx, { startDate: e.target.value })} /></td>
                    <td><input type="date" className="form-control form-control-sm" value={row.endDate} onChange={(e) => updateRow(setAppointments, appointments, idx, { endDate: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.designation} onChange={(e) => updateRow(setAppointments, appointments, idx, { designation: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.organization} onChange={(e) => updateRow(setAppointments, appointments, idx, { organization: e.target.value })} /></td>
                    <td><input className="form-control form-control-sm" value={row.reason} onChange={(e) => updateRow(setAppointments, appointments, idx, { reason: e.target.value })} /></td>
                    <td>
                      <select className="form-select form-select-sm" value={row.appointmentType} onChange={(e) => updateRow(setAppointments, appointments, idx, { appointmentType: e.target.value })}>
                        <option value="">Select</option>
                        {APPOINTMENT_HOLDING_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                      </select>
                    </td>
                    <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setAppointments(removeRow(appointments, idx, emptyAppointment))}>x</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setAppointments([...appointments, emptyAppointment()])}>Add Row</button>
            </>
          ) : null}
        </Box>

        <Box title="Upload File (Photo, Signature & Identification Certificate are mandatory)">
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>File Type</th>
                  <th>File Description</th>
                  <th>File Upload</th>
                  <th>File Download</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {attachments.map((row, idx) => (
                  <tr key={idx} className={idx === 0 ? "table-warning" : ""}>
                    <td>
                      <select className="form-select form-select-sm" value={row.fileType} onChange={(e) => updateRow(setAttachments, attachments, idx, { fileType: e.target.value })}>
                        <option value="">Select</option>
                        {fileTypeOptions.map((o) => <option key={o.type_id} value={o.type_id}>{o.type_text}</option>)}
                      </select>
                    </td>
                    <td><input className="form-control form-control-sm" value={row.fileDescription} onChange={(e) => updateRow(setAttachments, attachments, idx, { fileDescription: e.target.value })} /></td>
                    <td>
                      <input type="file" className="form-control form-control-sm" onChange={(e) => onFile(e.target.files?.[0], (name, content, mime) => updateRow(setAttachments, attachments, idx, { fileName: name, fileContent: content, fileMime: mime, fileDescription: row.fileDescription || name }))} />
                    </td>
                    <td>{row.fileName || "No file chosen"}</td>
                    <td><button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setAttachments(removeRow(attachments, idx, emptyAttachment))}>x</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setAttachments([...attachments, emptyAttachment()])}>Add Row</button>
        </Box>

        <Box>
          <ReqSelect
            label="11(B) If the previous employment was under the Government of India, State Government, an undertaking owned or controlled by Government of India/state government/autonomous body/university/local body. If you had left service on giving a month's notice, disciplinary proceedings framed against you or had been called upon to explain your conduct in any matter at the time you gave notice of termination of service or at a subsequent date before your services actually terminated"
            value={govtDisciplinaryProceedings}
            onChange={setGovtDisciplinaryProceedings}
            options={YES_NO_OPTIONS}
          />
        </Box>

        <Box title="12. Legal and Disciplinary Questions">
          {LEGAL_QUESTIONS.map((q) => (
            <div className="row g-2 align-items-center mb-2" key={q.key}>
              <div className="col-md-3 col-lg-2">
                <select className="form-select" value={legal[q.key]} onChange={(e) => setLegal((prev) => ({ ...prev, [q.key]: e.target.value }))}>
                  {YES_NO_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-9 col-lg-10">
                <label className="form-label mb-0"><Star /> {q.label}</label>
              </div>
            </div>
          ))}
        </Box>

        <Box title={`13. ${SECTION_13_PARTICULARS}`}>
          <div className="ea-note mb-3">
            <p className="mb-1">{SECTION_13A_NOTE}</p>
            <p className="mb-0">{SECTION_13B_NOTE}</p>
          </div>
          {/* <label className="form-label fw-semibold">Particulars (if any answer above is Yes)</label> */}
          <textarea className="form-control" rows={4} value={specificAnswers} onChange={(e) => setSpecificAnswers(e.target.value)} placeholder="Give full particulars of the case / arrest / detention / fine / conviction / sentence / punishment etc." />
        </Box>

        <Box title="14 Name and Address of two responsible persons of your locality or two references to whom you are known">
          <div className="row g-4">
            <div className="col-md-6">
              <ReqInput label="Name 1" value={reference1Name} onChange={setReference1Name} />
              <label className="form-label fw-semibold mt-2"><Star /> Address 1</label>
              <textarea className="form-control" rows={3} value={reference1Address} onChange={(e) => setReference1Address(e.target.value)} />
              <div className="mt-2">
                <ReqInput label="Mobile 1" value={reference1MobileNo} onChange={setReference1MobileNo} maxLength={10} />
              </div>
            </div>
            <div className="col-md-6">
              <ReqInput label="Name 2" value={reference2Name} onChange={setReference2Name} />
              <label className="form-label fw-semibold mt-2"><Star /> Address 2</label>
              <textarea className="form-control" rows={3} value={reference2Addresss} onChange={(e) => setReference2Addresss(e.target.value)} />
              <div className="mt-2">
                <ReqInput label="Mobile 2" value={reference2MobileNo} onChange={setReference2MobileNo} maxLength={10} />
              </div>
            </div>
          </div>
        </Box>

        <Box>
          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={declarationConfirmed} onChange={(e) => setDeclarationConfirmed(e.target.checked)} id="ea-decl" />
            <label className="form-check-label" htmlFor="ea-decl">
              <Star /> I certify that the foregoing information is correct and complete to the best of my knowledge and belief. I am not aware of any circumstances which might impair my fitness for employment under government.
            </label>
          </div>
        </Box>

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
          <button type="button" className="btn btn-danger" disabled={!!saving} onClick={() => handleSubmit("C")}>
            {saving === "C" ? <span className="spinner-border spinner-border-sm me-1" /> : null}
            Final Submit
          </button>
          <button type="button" className="btn btn-warning" disabled={!!saving} onClick={() => handleSubmit("D")}>
            {saving === "D" ? <span className="spinner-border spinner-border-sm me-1" /> : null}
            Save As Draft
          </button>
        </div>

        <IdentificationCertificate
          fullName={fullName}
          fatherName={(
            profileFatherName || getFatherNameFromFamilyRows(family)
          ).toUpperCase()}
          aadharNo={aadharNo}
          panNo={panNo}
        />
      </div>
      <style>{`
        .ea-warn { border: 1px solid #d35400; background: #fdf2e9; padding: 14px 16px; border-radius: 4px; }
        .ea-warn-title { color: #d35400; font-weight: 700; letter-spacing: 0.06em; margin-bottom: 8px; }
        .ea-note { border: 1px solid #aed6f1; background: #f4fbff; padding: 12px 14px; border-radius: 4px; color: #1f618d; }
        .ea-box { background: #eef6fb; border: 1px solid #b9d4ea; padding: 16px; margin-bottom: 16px; border-radius: 4px; }
        .ea-box h6 { color: #0b5c8a; font-weight: 700; }
        .ea-req { color: #d00; margin-right: 4px; }
      `}</style>
    </div>
  );
};

function mapMarital(value: any): string {
  const v = String(value || "").trim().toUpperCase();
  if (["MARR", "MARRIED", "M"].includes(v)) return "MARR";
  if (["SING", "SINGLE", "S", "UNMARRIED"].includes(v)) return "SING";
  if (["WID", "WIDOW", "WIDOWER"].includes(v)) return "WID";
  if (["DIV", "DIVORCED"].includes(v)) return "DIV";
  return v;
}

function updateRow<T>(setter: (rows: T[]) => void, rows: T[], idx: number, patch: Partial<T>) {
  setter(rows.map((row, i) => (i === idx ? { ...row, ...patch } : row)));
}

function removeRow<T>(rows: T[], idx: number, factory: () => T): T[] {
  const next = rows.filter((_, i) => i !== idx);
  return next.length ? next : [factory()];
}

function Star() {
  return <span className="ea-req">*</span>;
}

function Box({ title, children }: { title?: string; children: React.ReactNode }) {
  return (
    <div className="ea-box">
      {title ? <h6 className="mb-3">{title}</h6> : null}
      {children}
    </div>
  );
}

function Read({ label, value }: { label: string; value: string }) {
  return (
    <div className="col-md-6">
      <label className="form-label fw-semibold">{label}</label>
      <div className="form-control-plaintext py-1">{value}</div>
    </div>
  );
}

function ReqInput({
  label,
  value,
  onChange,
  type = "text",
  maxLength,
  required = true,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  maxLength?: number;
  required?: boolean;
}) {
  return (
    <div className="col-md-6">
      <label className="form-label fw-semibold">
        {required ? <Star /> : null}
        {label}
      </label>
      <input
        type={type}
        className="form-control"
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function ReqSelect({
  label,
  value,
  onChange,
  options,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
}) {
  return (
    <div className="col-md-6">
      <label className="form-label fw-semibold">
        <Star /> {label}
      </label>
      <select className="form-select" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Select</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default EAttestationForm;
